import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Page } from '../../../../models/page';
import { QuickLink } from '../../../../models/quick-link';
import { AssetService } from '../../../../services/asset.service';
import { QuickLinkService } from '../../../../services/quick-link.service';
import { HomeworkService } from '../../../../services/homework.service';
import { Subscription } from 'rxjs';
import { CommunicationService } from '../../../../services/communication.service';
import _ from 'lodash';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { QuickLinkUtils } from '../../../../utils/quick-link-utils';
import { SidebarService } from '../../../../services/sidebar.service';
import { TasksComponent } from '../../../sidebar/tasks/tasks.component';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-quicklink-overlay',
    templateUrl: './quicklink-overlay.component.html',
    styleUrls: ['./quicklink-overlay.component.scss'],
    standalone: true,
    imports: [
        NgStyle
    ]
})
export class QuicklinkOverlayComponent implements OnInit, OnDestroy {

    @Input() quickLink: QuickLink;
    @Input() page: Page;

    linkText: string;
    addedToHomework = false;

    addImage;
    removeImage;

    sidebarEventSubscription: Subscription;
    homeworkEventSubscription: Subscription;
    isDeactivated: boolean;
    tooltipPosition: string;

    hasPermissionToShow: boolean;
    isPageQuickLink: boolean;
    protected readonly TasksComponent = TasksComponent;

    constructor(public assetService: AssetService,
                private applicationStateService: ApplicationStateService,
                public homeworkService: HomeworkService,
                public sidebarService: SidebarService,
                private communicationService: CommunicationService,
                private quickLinkService: QuickLinkService) {

        setTimeout(() => {
            ($('[data-bs-toggle="tooltip"]') as any).tooltip();
        }, 500);

        // eslint-disable-next-line max-len
        this.homeworkEventSubscription = this.sidebarEventSubscription = this.communicationService.homeworkChangeAnnounced$.subscribe(() => {
            this.addedToHomework = this.isAddedToHomework();
        });
        this.addImage = `url(${this.assetService.getUrl('icon-hsm-plusbutton.png')})`;
        this.removeImage = `url(${this.assetService.getUrl('icon-hsm-remove.png')})`;
    }

    ngOnInit(): void {
        this.hasPermissionToShow = this.applicationStateService.bookConfig.bookPermissions.quickLinks.view;
        this.linkText = this.quickLinkService.convertQuickLink(this.quickLink.link);
        this.addedToHomework = this.homeworkService.containsActualHomework(this.linkText);
        this.isPageQuickLink = QuickLinkUtils.isQuicklinkLeadingToAPage(
            this.quickLink.link,
            this.applicationStateService.bookConfig.quickLinkPrefix
        );
        this.isDeactivated = _.includes(this.applicationStateService.globalVars.disabledAssignments,
            this.quickLink.slug);
        if (this.isDeactivated) {
            this.tooltipPosition = this.quickLink.position.y < 50 ? 'bottom' : 'top';
            ($('[data-bs-toggle="tooltip"]') as any).tooltip();
        }
    }

    ngOnDestroy(): void {
        this.sidebarEventSubscription.unsubscribe();
        this.homeworkEventSubscription.unsubscribe();
    }

    /**
     * add or remove link from exercise
     *
     * @param $event
     */
    async doAction($event): Promise<void> {
        let result = null;
        this.addedToHomework = this.isAddedToHomework();
        if (this.addedToHomework) {
            this.homeworkService.removeExercise(this.linkText);

            return;
        }
        await this.quickLinkService.findQuickLinks(this.quickLink.slug)
            .then(searchResult => {
                if (searchResult && Array.isArray(searchResult) && searchResult.length > 0) {
                    result = searchResult[0].quicklinksExtended.find(
                        ele => ele.prefix + ele.slug === this.quickLink.slug
                    );
                    if (result && result.related) {
                        const related = result.related.split(',');
                        related.forEach(ele => this.homeworkService.addExercise(ele));
                    }
                }
            }).catch(err => {
                console.error(err);
            });
        this.homeworkService.addExercise(this.linkText, this.quickLink.pageId, result?.teaser, result?.preview);

        $event.preventDefault();
    }

    private isAddedToHomework(): boolean {
        return this.homeworkService.containsActualHomework(this.linkText);
    }
}
